import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { ButtonColor, IconFunction, MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';
import { finalize, Observable, take } from 'rxjs';

@Component({
  selector: 'app-long-action-button',
  standalone: true,
  imports: [MotifButtonModule, MotifIconModule],
  templateUrl: './long-action-button.component.html',
  styleUrl: './long-action-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LongActionButtonComponent {
  readonly iconFunction = input<IconFunction>();
  readonly label = input<string | null>(null);
  readonly color = input<ButtonColor>('primary');
  readonly action$ = input.required<Observable<boolean>>();
  readonly variant = input<'button' | 'text'>('button');
  readonly loadingText = input<string | undefined>(undefined);
  readonly disabled = input<boolean>(false);

  readonly isLoading = signal<boolean>(false);
  readonly isDisabled = computed(() => this.isLoading() || this.disabled());

  public onClick(): void {
    this.isLoading.set(true);

    this.action$()
      .pipe(
        take(1),
        finalize(() => {
          this.isLoading.set(false);
        })
      )
      .subscribe();
  }
}
